export default __webpack_public_path__ + "static/infura-dfbb46b15d4b1c25000c6377631eadec.png";